import { customElement } from 'lit/decorators.js'
import { html, LitElement, nothing, type CSSResultGroup } from 'lit'
import { consume } from '@lit/context'
import { style } from './configurator-step-list.style.js'
import { StepDataDTO } from 'components/ordering/configurator/api/dtos/step-data-dto.js'
import { CSCConfiguratorStep } from 'components/ordering/configurator/components/step/configurator-step.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import {
  configuratorStepsContext,
  NotFetchedYet
} from 'components/ordering/configurator/components/context/context-definition.js'

@customElement('csc-configurator-step-list')
export class CSCConfiguratorStepList extends LitElement {
  static override styles?: CSSResultGroup = [hostStyle, style]

  @consume({ context: configuratorStepsContext, subscribe: true })
  steps!: StepDataDTO[] | NotFetchedYet

  override render() {
    if (this.steps instanceof NotFetchedYet) return nothing

    return html`${this.steps.map(step => html`${new CSCConfiguratorStep({ step })}`)}`
  }
}
